import hasRole from './permission/hasRole'
import hasPermi from './permission/hasPermi'
import copyText from './common/copyText'
import isInnerAdmin from "@/directive/permission/isInnerAdmin";
import isAdmin from "@/directive/permission/isAdmin";

export default function directive(app) {
    app.directive('hasRole', hasRole);
    app.directive('hasPermi', hasPermi);
    app.directive('copyText', copyText);
    app.directive('isInnerAdmin', isInnerAdmin);
    app.directive('isAdmin', isAdmin);
}